import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M14.646 18.987a2.25 2.25 0 0 0 2.25-2.25V4.251a2.25 2.25 0 0 0-2.25-2.25h-3.95a2.25 2.25 0 0 0-1.592.66l-4.35 4.352a2.25 2.25 0 0 0-.658 1.59v8.134a2.25 2.25 0 0 0 2.25 2.25zm.75-2.25a.75.75 0 0 1-.75.75h-8.3a.75.75 0 0 1-.75-.75V8.733h2.982a2.25 2.25 0 0 0 2.25-2.251L10.826 3.5h3.82a.75.75 0 0 1 .75.75zM9.326 4.56 6.656 7.233h1.923a.75.75 0 0 0 .75-.75zm-1.341 7.277a.75.75 0 0 0 0 1.5h5.022a.75.75 0 0 0 0-1.5zm0 2.511a.75.75 0 1 0 0 1.5h2.511a.75.75 0 0 0 0-1.5zm10.421-8.665a.75.75 0 0 1 1.5 0V17.25a4.75 4.75 0 0 1-4.75 4.75H7.798a.75.75 0 1 1 0-1.5h7.358a3.25 3.25 0 0 0 3.25-3.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }